import React, { useState, useEffect } from 'react';
import { RightArrowIcon } from '@/components/common/icon';
import { useTranslation } from 'react-i18next';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';

// 接单 分步骤 面包屑导航

const ModalAnalysisBreadcrumb: React.FC<{ index: number }> = ({ index }) => {
  const { t } = useTranslation();
  const { titleType } = useDetailDataStore();
  const myRateTitle = titleType === 'my_rate';
  return (
    <div className="flex items-center mt-2 md:mt-0 gap-1 overflow-x-auto whitespace-nowrap pb-1">
      <div
        className={`shrink-0 pl-1 pr-1.5 py-1.5 rounded justify-center items-center gap-2.5 inline-flex ${
          index === 0 ? 'bg-[#f1f3f4]' : 'bg-transparent'
        }`}
      >
        <div className="text-[#60646c] text-xs font-medium font-['Inter'] pl-2 whitespace-nowrap">
          {t('modal.analysis.breadcrumb.step1', {
            defaultValue: '1. Share audience insights'
          })}
        </div>
      </div>
      <RightArrowIcon className="shrink-0" />
      <div
        className={`shrink-0 pl-1 pr-1.5 py-1.5 rounded justify-center items-center gap-2.5 inline-flex ${
          index === 1 ? 'bg-[#f1f3f4]' : 'bg-transparent'
        }`}
      >
        <div className="text-[#60646c] text-xs font-medium font-['Inter'] pl-2 whitespace-nowrap">
          {myRateTitle
            ? t('modal.analysis.breadcrumb.step2_my_rate', {
                defaultValue: '2. Set my own rate'
              })
            : t('modal.analysis.breadcrumb.step2', {
                defaultValue: '2. Share rate'
              })}
        </div>
      </div>
      <RightArrowIcon className="shrink-0" />
      <div
        className={`shrink-0 pl-1 pr-1.5 py-1.5 rounded justify-center items-center gap-2.5 inline-flex ${
          index === 2 ? 'bg-[#f1f3f4]' : 'bg-transparent'
        }`}
      >
        <div className="text-[#60646c] text-xs font-medium font-['Inter'] pl-2 whitespace-nowrap">
          {t('modal.analysis.breadcrumb.step3', {
            defaultValue: '3. Submit interest'
          })}
        </div>
      </div>
    </div>
  );
};

export default ModalAnalysisBreadcrumb;
